module.exports = __webpack_public_path__ + "static/flags/CZ-2103b0cc58875d80b790f25c72ce8698.gif";